import { render, staticRenderFns } from "./FailureReasons.vue?vue&type=template&id=98753894"
import script from "./FailureReasons.vue?vue&type=script&lang=js"
export * from "./FailureReasons.vue?vue&type=script&lang=js"
import style0 from "./FailureReasons.vue?vue&type=style&index=0&id=98753894&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98753894')) {
      api.createRecord('98753894', component.options)
    } else {
      api.reload('98753894', component.options)
    }
    module.hot.accept("./FailureReasons.vue?vue&type=template&id=98753894", function () {
      api.rerender('98753894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Activity/Conversion/FailureReasons.vue"
export default component.exports